import React, { useContext } from 'react';
import BoxShadow from '../../atoms/BoxShadow';
import { Comparisons, Comparison as StyledComparison, Link, } from './components';
import { purify } from '../../utils/helpers';
import EmbeddedContext from '../../configuration/context/embedded';
function AdditionalComparisons({ data }) {
    const { isEmbedded } = useContext(EmbeddedContext);
    if (!data) {
        return null;
    }
    return (React.createElement(BoxShadow, null,
        React.createElement(Comparisons, null, data.map(({ headline, cta }, i) => (React.createElement(StyledComparison, { key: `additional-${i}` },
            React.createElement("span", { dangerouslySetInnerHTML: { __html: purify(headline) } }),
            cta && !isEmbedded && React.createElement(Link, Object.assign({ standalone: true }, cta))))))));
}
export default AdditionalComparisons;
//# sourceMappingURL=additional-comparisons.js.map